import { makeStyles } from "@material-ui/core";

export const usePageNavigationListStyles = makeStyles(() => ({
    hide: {
        display: 'none',
    }
}));
